import { createSelector } from 'reselect';
import { partition } from 'lodash/fp';

import t from '../utils/translate';
import * as TabTypes from '../constants/tabTypes';
import { getColumns } from '../utils/challengeUtils';
import routeFilterSelector from './routeFilterSelector';

function getChallenges(
  upcomingChallenges,
  liveChallenges,
  completedChallenges,
  isSignedIn,
  routeFilter
) {
  const [myLive, otherLive] = partition('hasEntered', liveChallenges);

  return [
    {
      key: 'upcoming',
      id: TabTypes.UPCOMING,
      title: t('Upcoming Challenges'),
      challenges: routeFilter(upcomingChallenges),
      columns: getColumns({ live: false, entered: false }),
      alwaysShow: true,
      emptyTitle: t('No Upcoming Challenges'),
      emptyMessage: t('Upcoming challenges will appear here')
    },
    {
      key: 'my live',
      id: TabTypes.LIVE,
      title: t('My Live Challenges'),
      challenges: routeFilter(myLive),
      columns: getColumns({ live: true, entered: true }),
      alwaysShow: true,
      emptyTitle: t('No Live Challenges'),
      emptyMessage: t('The challenges that you entered will appear here')
    },
    {
      key: 'other live',
      id: TabTypes.LIVE,
      title: t('Other Live Challenges'),
      challenges: routeFilter(otherLive),
      columns: getColumns({ live: true, entered: false }),
      alwaysShow: true,
      emptyTitle: t('No Other Live Challenges'),
      emptyMessage: t('There are no other live challenges')
    },
    {
      key: 'completed',
      id: TabTypes.COMPLETED,
      title: t('Recently Completed'),
      challenges: routeFilter(completedChallenges),
      columns: getColumns({ live: true, entered: true }),
      alwaysShow: true,
      emptyTitle: t('No Recently Completed Challenges'),
      emptyMessage: isSignedIn
        ? t('The recently completed challenges that you entered will appear here')
        : t('Sign in to see your recently completed challenges')
    }
  ];
}

const trainerChallengesSelector = createSelector(
  state => state.trainerChallenges.upcomingChallenges,
  state => state.trainerChallenges.liveChallenges,
  state => state.trainerChallenges.completedChallenges,
  state => state.user.isSignedIn,
  routeFilterSelector,
  getChallenges
);

export default trainerChallengesSelector;
